<template>
    <div class="c-job">
        <div class="head-box"><navBar :isNav2="true"></navBar></div>
        <div class="content">
            <!-- 面包屑 -->
            <div class="breadbox">
                <div class="container1">
                    <div class="f_cont">
                        <router-link to="/">首页</router-link>
                        <span>&gt;</span>
                        <router-link :to="{ name: 'joinUs' }">加入我们</router-link>
                        <span>&gt;</span>
                        <a href="javascript:;">招聘信息</a>
                    </div>
                </div>
            </div>
            <!-- 招聘内容1 -->
            <div class="c-job-1">
                <div class="container1">
                    <div class="c-left">
                        <h1 class="c-title font40 pingFang-Bold">招聘信息</h1>
                        <div class="c-main">
                            <div class="c-top font18 pingFang-Bold">
                                <p>筛选</p>
                                <p>清除</p>
                            </div>
                            <div class="c-item0">
                                <h3 class="c-title2 pingFang-Bold font20">招聘方式</h3>
                                <el-checkbox-group v-model="checkList1">
                                    <div class="c-item"><el-checkbox label="全部"></el-checkbox></div>
                                    <div class="c-item">
                                        <el-checkbox label="招聘招聘"></el-checkbox>
                                        <div class="c-num">
                                            <span></span>
                                            （20）
                                        </div>
                                    </div>
                                    <div class="c-item">
                                        <el-checkbox label="校园招聘"></el-checkbox>
                                        <div class="c-num">
                                            <span></span>
                                            （20）
                                        </div>
                                    </div>
                                </el-checkbox-group>
                            </div>
                            <div class="c-item0">
                                <h3 class="c-title2 pingFang-Bold font20">职位类别</h3>
                                <el-checkbox-group v-model="checkList2">
                                    <div class="c-item"><el-checkbox label="全部"></el-checkbox></div>
                                    <div class="c-item"><el-checkbox label="研发类"></el-checkbox></div>
                                    <div class="c-item"><el-checkbox label="产品类"></el-checkbox></div>
                                    <div class="c-item"><el-checkbox label="营销类"></el-checkbox></div>
                                    <div class="c-item"><el-checkbox label="设计类"></el-checkbox></div>
                                    <div class="c-item"><el-checkbox label="职能类"></el-checkbox></div>
                                </el-checkbox-group>
                            </div>
                            <div class="c-item0">
                                <h3 class="c-title2 pingFang-Bold font20">城市</h3>
                                <el-checkbox-group v-model="checkList3">
                                    <div class="c-item"><el-checkbox label="北京"></el-checkbox></div>
                                    <div class="c-item"><el-checkbox label="上海"></el-checkbox></div>
                                    <div class="c-item"><el-checkbox label="深圳"></el-checkbox></div>
                                    <div class="c-item">
                                        <div class="c-btn">
                                            <span class="el-icon-plus"></span>
                                            <p>更多</p>
                                        </div>
                                    </div>
                                </el-checkbox-group>
                            </div>
                        </div>
                    </div>
                    <div class="c-right">
                        <h2 class="c-main-title font30 pingFang-Bold">开启新的工作</h2>
                        <ul class="c-list">
                            <li>
                                <div class="c-title-box">
                                    <div class="c-lt">
                                        <h3 class="c-title font20 pingFang-Bold">增值经理</h3>
                                        <p class="c-text">
                                            工作地点：
                                            <span>深圳</span>
                                            <span>营销类</span>
                                        </p>
                                    </div>
                                    <div class="c-gt">
                                        <p>2022-7-1发布</p>
                                        <div class="c-btn">立即申请</div>
                                        <div class="c-arrow"><span class="el-icon-arrow-down"></span></div>
                                    </div>
                                </div>
                                <div class="c-content">
                                    <p>
                                        <strong>工作内容：</strong>
                                        <br />
                                        1、通过电话、在线、面见等方式服务使用“上上参谋”招商的品牌客户，提供并定制相应增值营销方案；
                                        <br />
                                        2、维系和影响长期客户，挖掘潜在需求，激活多产品需求，有效提升客户推广预算；
                                        <br />
                                        3、负责合作用户续费及二次产品营销，完成部门营销计划及销售指标；
                                        <br />
                                        4、指导客户合理有效地使用上上参谋品牌招商推广服务，提升客户使用的推广效果；
                                        <br />
                                        5、积极配合团队主管开展工作，有效完成业务流程中工作职责。
                                        <br />
                                        <br />
                                        <strong>任职条件：</strong>
                                        <br />
                                        1、统招本科及以上学历；
                                        <br />
                                        2、5年及以上相关工作经验及团队管理经验，具有销售/客户服务/二次开发工作经验者优先；
                                        <br />
                                        3、普通话标准，口齿清晰，具备优秀的沟通表达能力及较强的客户服务意识；
                                        <br />
                                        4、热情开朗，积极上进，具有良好的团队合作精神，能够承受较大的工作压力，结果导向。
                                        <br />
                                        5、熟练使用Office办公软件。
                                    </p>
                                </div>
                            </li>
                            <li>
                                <div class="c-title-box">
                                    <div class="c-lt">
                                        <h3 class="c-title font20 pingFang-Bold">增值经理</h3>
                                        <p class="c-text">
                                            工作地点：
                                            <span>深圳</span>
                                            <span>营销类</span>
                                        </p>
                                    </div>
                                    <div class="c-gt">
                                        <p>2022-7-1发布</p>
                                        <div class="c-btn">立即申请</div>
                                        <div class="c-arrow"><span class="el-icon-arrow-down"></span></div>
                                    </div>
                                </div>
                                <div class="c-content">
                                    <p>
                                        <strong>工作内容：</strong>
                                        <br />
                                        1、通过电话、在线、面见等方式服务使用“上上参谋”招商的品牌客户，提供并定制相应增值营销方案；
                                        <br />
                                        2、维系和影响长期客户，挖掘潜在需求，激活多产品需求，有效提升客户推广预算；
                                        <br />
                                        3、负责合作用户续费及二次产品营销，完成部门营销计划及销售指标；
                                        <br />
                                        4、指导客户合理有效地使用上上参谋品牌招商推广服务，提升客户使用的推广效果；
                                        <br />
                                        5、积极配合团队主管开展工作，有效完成业务流程中工作职责。
                                        <br />
                                        <br />
                                        <strong>任职条件：</strong>
                                        <br />
                                        1、统招本科及以上学历；
                                        <br />
                                        2、5年及以上相关工作经验及团队管理经验，具有销售/客户服务/二次开发工作经验者优先；
                                        <br />
                                        3、普通话标准，口齿清晰，具备优秀的沟通表达能力及较强的客户服务意识；
                                        <br />
                                        4、热情开朗，积极上进，具有良好的团队合作精神，能够承受较大的工作压力，结果导向。
                                        <br />
                                        5、熟练使用Office办公软件。
                                    </p>
                                </div>
                            </li>
                            <li>
                                <div class="c-title-box">
                                    <div class="c-lt">
                                        <h3 class="c-title font20 pingFang-Bold">增值经理</h3>
                                        <p class="c-text">
                                            工作地点：
                                            <span>深圳</span>
                                            <span>营销类</span>
                                        </p>
                                    </div>
                                    <div class="c-gt">
                                        <p>2022-7-1发布</p>
                                        <div class="c-btn">立即申请</div>
                                        <div class="c-arrow"><span class="el-icon-arrow-down"></span></div>
                                    </div>
                                </div>
                                <div class="c-content">
                                    <p>
                                        <strong>工作内容：</strong>
                                        <br />
                                        1、通过电话、在线、面见等方式服务使用“上上参谋”招商的品牌客户，提供并定制相应增值营销方案；
                                        <br />
                                        2、维系和影响长期客户，挖掘潜在需求，激活多产品需求，有效提升客户推广预算；
                                        <br />
                                        3、负责合作用户续费及二次产品营销，完成部门营销计划及销售指标；
                                        <br />
                                        4、指导客户合理有效地使用上上参谋品牌招商推广服务，提升客户使用的推广效果；
                                        <br />
                                        5、积极配合团队主管开展工作，有效完成业务流程中工作职责。
                                        <br />
                                        <br />
                                        <strong>任职条件：</strong>
                                        <br />
                                        1、统招本科及以上学历；
                                        <br />
                                        2、5年及以上相关工作经验及团队管理经验，具有销售/客户服务/二次开发工作经验者优先；
                                        <br />
                                        3、普通话标准，口齿清晰，具备优秀的沟通表达能力及较强的客户服务意识；
                                        <br />
                                        4、热情开朗，积极上进，具有良好的团队合作精神，能够承受较大的工作压力，结果导向。
                                        <br />
                                        5、熟练使用Office办公软件。
                                    </p>
                                </div>
                            </li>
                            <li>
                                <div class="c-title-box">
                                    <div class="c-lt">
                                        <h3 class="c-title font20 pingFang-Bold">增值经理</h3>
                                        <p class="c-text">
                                            工作地点：
                                            <span>深圳</span>
                                            <span>营销类</span>
                                        </p>
                                    </div>
                                    <div class="c-gt">
                                        <p>2022-7-1发布</p>
                                        <div class="c-btn">立即申请</div>
                                        <div class="c-arrow"><span class="el-icon-arrow-down"></span></div>
                                    </div>
                                </div>
                                <div class="c-content">
                                    <p>
                                        <strong>工作内容：</strong>
                                        <br />
                                        1、通过电话、在线、面见等方式服务使用“上上参谋”招商的品牌客户，提供并定制相应增值营销方案；
                                        <br />
                                        2、维系和影响长期客户，挖掘潜在需求，激活多产品需求，有效提升客户推广预算；
                                        <br />
                                        3、负责合作用户续费及二次产品营销，完成部门营销计划及销售指标；
                                        <br />
                                        4、指导客户合理有效地使用上上参谋品牌招商推广服务，提升客户使用的推广效果；
                                        <br />
                                        5、积极配合团队主管开展工作，有效完成业务流程中工作职责。
                                        <br />
                                        <br />
                                        <strong>任职条件：</strong>
                                        <br />
                                        1、统招本科及以上学历；
                                        <br />
                                        2、5年及以上相关工作经验及团队管理经验，具有销售/客户服务/二次开发工作经验者优先；
                                        <br />
                                        3、普通话标准，口齿清晰，具备优秀的沟通表达能力及较强的客户服务意识；
                                        <br />
                                        4、热情开朗，积极上进，具有良好的团队合作精神，能够承受较大的工作压力，结果导向。
                                        <br />
                                        5、熟练使用Office办公软件。
                                    </p>
                                </div>
                            </li>
                            <li>
                                <div class="c-title-box">
                                    <div class="c-lt">
                                        <h3 class="c-title font20 pingFang-Bold">增值经理</h3>
                                        <p class="c-text">
                                            工作地点：
                                            <span>深圳</span>
                                            <span>营销类</span>
                                        </p>
                                    </div>
                                    <div class="c-gt">
                                        <p>2022-7-1发布</p>
                                        <div class="c-btn">立即申请</div>
                                        <div class="c-arrow"><span class="el-icon-arrow-down"></span></div>
                                    </div>
                                </div>
                                <div class="c-content">
                                    <p>
                                        <strong>工作内容：</strong>
                                        <br />
                                        1、通过电话、在线、面见等方式服务使用“上上参谋”招商的品牌客户，提供并定制相应增值营销方案；
                                        <br />
                                        2、维系和影响长期客户，挖掘潜在需求，激活多产品需求，有效提升客户推广预算；
                                        <br />
                                        3、负责合作用户续费及二次产品营销，完成部门营销计划及销售指标；
                                        <br />
                                        4、指导客户合理有效地使用上上参谋品牌招商推广服务，提升客户使用的推广效果；
                                        <br />
                                        5、积极配合团队主管开展工作，有效完成业务流程中工作职责。
                                        <br />
                                        <br />
                                        <strong>任职条件：</strong>
                                        <br />
                                        1、统招本科及以上学历；
                                        <br />
                                        2、5年及以上相关工作经验及团队管理经验，具有销售/客户服务/二次开发工作经验者优先；
                                        <br />
                                        3、普通话标准，口齿清晰，具备优秀的沟通表达能力及较强的客户服务意识；
                                        <br />
                                        4、热情开朗，积极上进，具有良好的团队合作精神，能够承受较大的工作压力，结果导向。
                                        <br />
                                        5、熟练使用Office办公软件。
                                    </p>
                                </div>
                            </li>
                        </ul>
                        <el-pagination
                            :page-size="size"
                            :pager-count="count1"
                            layout="prev, pager, next"
                            :current-page="page"
                            :total="total"
                            @current-change="Curpage"
                            class="basepage"
                        ></el-pagination>
                    </div>
                </div>
            </div>
            <!-- 数位弹窗 -->
            <form action="" id="sw-message">
                <div class="sw-message">
                    <div class="container1">
                        <p class="sw-close">
                            <span></span>
                            <span></span>
                        </p>
                        <p class="cn1 font30">职位申请</p>

                        <div class="box">
                            <p class="cn2"><input type="text" placeholder="姓名*" class="font14 z-name" /></p>
                            <p class="cn2"><input type="text" placeholder="联系方式*" class="font14 z-tel" /></p>
                            <p class="cn2"><input type="text" placeholder="邮箱*" class="font14 z-email" /></p>
                        </div>

                        <div class="box2">
                            <p class="cn3 font14">
                                简历上传：
                                <br />
                                大小不超过5M，支持.Doc,.Docx,.Pdf
                            </p>
                            <div class="hi-file-box cn4">
                                <div class="hi-input-box">
                                    <p class="hi-text ztext font12">上传简历</p>
                                    <input type="file" class="hi-file zfile" name="file" value="Upload" accept=".pdf,.doc,.docx,.xls,.xlsx" />
                                </div>
                            </div>
                        </div>

                        <div class="box2">
                            <p class="cn3 font14">
                                相关资料：
                                <br />
                                上传大小不超过10M，支持.Doc,.Docx,.Pdf
                            </p>
                            <div class="hi-file-box cn4">
                                <div class="hi-input-box">
                                    <p class="hi-text ztext3 font12">上传文件</p>
                                    <input type="file" class="hi-file zfile3" name="file" value="Upload" accept=".pdf,.doc,.docx,.xls,.xlsx" />
                                </div>
                            </div>
                        </div>

                        <div class="box box3">
                            <p class="cn2 cn5"><input type="text" placeholder=" 其他或链接" class="font14" /></p>
                        </div>

                        <p class="cn6 font14">若为链接请在下方填写，若文件过大请发送至邮箱： www.lalal1XX1.com，并在上方备注</p>
                        <button type="button" class="cn7">提交</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import navBar from '../components/navBar.vue';
export default {
    name: '',
    data() {
        return {
            checkList1: [],
            checkList2: [],
            checkList3: [],
            size: 5,
            page: 1,
            count1: 4,
            total: 60
        };
    },
    created() {},
    mounted() {
        this.$nextTick(() => {
            // 列表下拉收缩
            $('#app').on('click', '.c-job-1 .c-list li .c-title-box', function(event) {
                event.stopPropagation();
                $(this)
                    .next()
                    .stop()
                    .slideToggle();
                $(this)
                    .find('.c-arrow')
                    .toggleClass('on');
            });
            $('#app').on('click', '.c-job-1 .c-list li .c-title-box .c-btn', function(event) {
                event.stopPropagation();
                $('#sw-message')
                    .stop()
                    .fadeIn();
            });

            // 简历上传
            var oResumeBox = $('#sw-message');
            $('#sw-message .sw-close').click(function(event) {
                event.stopPropagation();
                oResumeBox.stop().fadeOut();
            });
            $('#sw-message').click(function(event) {
                event.stopPropagation();
                oResumeBox.stop().fadeOut();
            });
            $('#sw-message .container1').click(function(event) {
                event.stopPropagation();
            });
            $('#sw-message .box2').each(function() {
                var oText = $(this).find('.hi-text'); //上传简历名
                var oInput = $(this).find('.hi-file'); //上传文本框
                var sFileName = '';
                // 设置上传文件名
                oInput.change(function(event) {
                    sFileName = $(this)
                        .val()
                        .split('\\');
                    sFileName = sFileName[sFileName.length - 1];
                    oText.text('已上传：' + sFileName);
                });
            });
        });
        setTimeout(() => {}, 500);
    },
    computed: {},
    methods: {
        Curpage(val) {
            this.page = val;
        }
    },
    components: { navBar },
    beforeDestroy() {},
    watch: {}
};
</script>

<style scoped lang="less">
::v-deep .navBar-box {
    z-index: 100;
    background: #fff;
    box-shadow: 0 4px 40px rgba(50, 51, 51, 0.06);
    .navbar .nav-link {
        color: #333333;
    }
    .navbar .right-box .el-dropdown-link,
    .navbar {
        color: #333;
    }
    .navbar .nav-link .arrow {
        background-image: url(../assets/images/arrow-down2.svg);
    }
    .navbar .navbar-toggler .icon-caidan {
        color: #333;
    }
    .navbar .navbar-collapse {
        @media @max-sm {
            position: absolute;
            top: 80px;
            left: 0;
            width: 100%;
            padding: 0 20px;
            background: #fff;
            overflow: hidden;
        }
    }
    .left-box {
        @media @max-sm {
            display: flex;
            align-items: center;
            height: 60px;
        }
    }
}
.breadbox {
    padding-top: 80px;
    background: #fafafa;
}
.c-job {
    .head-box {
        width: 100%;
        height: 80px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 90;
        background-color: #ffffff;
    }
    // banner
    // 招聘内容1
    .c-job-1 {
        padding: 90px 0 140px;
        background: #fafafa;
        color: #333;
        @media @max-xs {
            padding: 60px 0;
        }
        .container1 {
            display: flex;
            align-items: flex-start;
            @media @max-sm {
                flex-wrap: wrap;
            }
            .c-left {
                flex-shrink: 0;
                width: 310px;
                @media @max-md {
                    width: 220px;
                }
                @media @max-sm {
                    width: 100%;
                }
                .c-title {
                    margin-bottom: 50px;
                    @media @max-xs {
                        margin-bottom: 30px;
                    }
                }
                .c-main {
                    padding-right: 35px;
                    border-right: 1px solid #e3e6e6;
                    @media @max-sm {
                        padding: 0;
                        border: 0;
                    }
                    .c-top {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding-bottom: 10px;
                        margin-bottom: 20px;
                        border-bottom: 1px solid #e3e6e6;
                        p:nth-of-type(2) {
                            color: #999;
                        }
                    }
                    .c-item0 {
                        margin-bottom: 40px;
                        @media @max-sm {
                            margin-bottom: 20px;
                        }
                        @media @max-xs {
                            margin-bottom: 5px;
                        }
                        &:last-child {
                            margin: 0;
                        }
                        .c-title2 {
                            margin-bottom: 20px;
                            @media @max-sm {
                                margin-bottom: 10px;
                            }
                        }
                        .c-item {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            margin-bottom: 22px;
                            @media @max-sm {
                                margin: 0 20px 10px 0;
                                display: inline-flex;
                            }
                            .c-num {
                                display: flex;
                                align-items: center;
                                font-size: 14px;
                                color: #8f959e;
                                @media @max-sm {
                                    margin-left: 10px;
                                }
                                span {
                                    display: inline-block;
                                    width: 16px;
                                    height: 16px;
                                    background: url(../assets/images/user.svg) no-repeat center / contain;
                                }
                            }
                            .c-btn {
                                display: flex;
                                align-items: center;
                                color: #ea5404;
                                font-size: 16px;
                                cursor: pointer;
                            }
                        }
                        ::v-deep .el-checkbox {
                            margin-bottom: 0;
                            .el-checkbox__input.is-focus .el-checkbox__inner,
                            .el-checkbox__input:hover .el-checkbox__inner {
                                border: 1px solid #dcdfe6;
                            }
                            .el-checkbox__input.is-checked {
                                .el-checkbox__inner {
                                    border-color: #ea5404;
                                    background: #ea5404;
                                }
                                + .el-checkbox__label {
                                    color: #ea5404;
                                }
                            }
                            .el-checkbox__inner {
                                width: 18px;
                                height: 18px;
                                &::after {
                                    left: 6px;
                                    top: 3px;
                                }
                                .el-checkbox__label {
                                    line-height: 18px;
                                }
                            }
                            .el-checkbox__label {
                                font-size: 16px;
                            }
                        }
                    }
                }
            }
            .c-right {
                padding-left: 40px;
                width: 100%;
                @media @max-sm {
                    padding-left: 0;
                }
                .c-main-title {
                    margin: 92px 0 20px;
                    @media @max-xs {
                        margin: 30px 0 20px;
                    }
                }
                .c-list {
                    li {
                        margin-bottom: 10px;
                        background: #fff;
                        &:last-child {
                            margin-bottom: 80px;
                            @media @max-xs {
                                margin-bottom: 30px;
                            }
                        }
                        .c-title-box {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            padding: 35px 40px;
                            @media @max-xs {
                                padding: 20px;
                                flex-wrap: wrap;
                            }
                            .c-lt {
                                @media @max-xs {
                                    margin-bottom: 10px;
                                    width: 100%;
                                }
                                .c-title {
                                    margin-bottom: 5px;
                                }
                                .c-text {
                                    color: #8f959e;
                                    span {
                                        margin-right: 40px;
                                        @media @max-md {
                                            margin-right: 20px;
                                        }
                                    }
                                }
                            }
                            .c-gt {
                                display: flex;
                                align-items: center;
                                color: #8f959e;
                                .c-btn {
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    margin: 0 60px;
                                    width: 120px;
                                    height: 40px;
                                    border-radius: 20px;
                                    background: #ea5404;
                                    color: #fff;
                                    cursor: pointer;
                                    @media @max-md {
                                        margin: 0 20px;
                                    }
                                }
                                .c-arrow {
                                    font-size: 22px;
                                    color: #8f959e;
                                    cursor: pointer;
                                    transition: all 0.3s;
                                    &.on {
                                        transform: rotate(180deg);
                                    }
                                }
                            }
                        }
                        .c-content {
                            display: none;
                            padding: 0 40px 60px;
                            color: #666666;
                        }
                    }
                }
            }
        }
    }
}

.font12 {
    font-size: 12px;
}
#sw-message {
    display: none;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 901;
    background-color: rgba(0, 0, 0, 0.8);
}
.sw-message .container1 {
    border-radius: 10px;
    padding: 60px 120px;
    background-color: #fff;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    max-width: 1200px;
}
@media (max-width: 1580px) {
    .sw-message .container1 {
        padding: 30px 60px;
    }
}
@media (max-width: 1260px) {
    .sw-message .container1 {
        padding: 30px;
    }
}
@media (max-width: 767px) {
    .sw-message .container1 {
        padding: 5%;
    }
}
.sw-message .container1 .sw-close {
    position: absolute;
    right: 40px;
    top: 30px;
    width: 20px;
    height: 20px;
    cursor: pointer;
}
.sw-message .container1 .sw-close span {
    width: 20px;
    height: 2px;
    background-color: #999;
    display: block;
    transition: all 0.3s;
}
.sw-message .container1 .sw-close:hover span {
    background-color: #ea5404;
}
.sw-message .container1 .sw-close span:nth-child(1) {
    position: absolute;
    right: 0;
    top: 50%;
    transform: rotate(45deg);
}
.sw-message .container1 .sw-close span:nth-child(2) {
    position: absolute;
    right: 0;
    top: 50%;
    transform: rotate(-45deg);
}
.sw-message .container1 .cn1 {
    text-align: center;
}
.sw-message .container1 .box {
    margin-top: 40px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
@media (max-width: 767px) {
    .sw-message {
        font-size: 14px;
    }
    .sw-message .container1 .box {
        margin-top: 15px;
    }
    .sw-message .container1 .sw-close {
        right: 20px;
        top: 20px;
    }
}
.sw-message .container1 .box.box3 {
    margin-top: 15px;
}
@media (max-width: 767px) {
    .sw-message .container1 .box.box3 {
        margin-top: 0;
    }
}
.sw-message .container1 .box .cn2 {
    width: 32%;
}
@media (max-width: 767px) {
    .sw-message .container1 .box .cn2 {
        width: 100%;
        margin-top: 15px;
    }
}
.sw-message .container1 .box .cn2.cn5 {
    width: 100%;
}
.sw-message .container1 .box .cn2 input {
    line-height: 48px;
    width: 100%;
    background-color: #f5f5f7;
    border: solid 1px #ededed;
    color: #999999;
    padding: 0 20px;
}
@media (max-width: 767px) {
    .sw-message .container1 .box .cn2 input {
        line-height: 40px;
        padding: 0 10px;
    }
}
.sw-message .container1 .box .cn2 input::-webkit-input-placeholder {
    color: #999;
}
.sw-message .container1 .box .cn2 input::-moz-placeholder {
    color: #999;
}
.sw-message .container1 .box .cn2 input::placeholder {
    color: #999;
}
.sw-message .container1 .box2 {
    margin-top: 15px;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #f5f5f7;
    border: solid 1px #ededed;
}
@media (max-width: 767px) {
    .sw-message .container1 .box2 {
        flex-wrap: wrap;
        padding: 10px;
    }
    .sw-message .container1 .box2 .cn3 {
        margin-bottom: 5px;
    }
}
.sw-message .container1 .box2 .cn3 {
    color: #999999;
    line-height: 1.3em;
}
.sw-message .container1 .box2 .cn4.hi-file-box {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.sw-message .container1 .box2 .cn4.hi-file-box .hi-input-box {
    position: relative;
    display: inline-block;
    background-color: #333;
    border-radius: 4px;
    border: 0;
    padding: 0;
    text-align: center;
}
.sw-message .container1 .box2 .cn4.hi-file-box input {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    margin-bottom: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    border: 0;
    cursor: pointer;
}
.sw-message .container1 .box2 .cn4.hi-file-box .hi-text {
    padding: 5px 10px;
    color: #fff;
}
.sw-message .container1 .box2 .cn4.hi-file-box .hi-text2 {
    line-height: 40px;
}
.sw-message .container1 .cn6 {
    margin-top: 5px;
    color: #b3b3b3;
    line-height: 2em;
}
@media (max-width: 767px) {
    .sw-message .container1 .cn6 {
        display: none;
        line-height: 1.5em;
    }
}
.sw-message .container1 .cn7 {
    width: 190px;
    height: 53px;
    background-color: #ff5d00;
    border-radius: 26px;
    text-align: center;
    margin: 50px auto 0;
    color: #fff;
    display: block;
    transition: all 0.5s;
}
@media (max-width: 767px) {
    .sw-message .container1 .cn7 {
        width: 100px;
        height: 40px;
        margin: 15px auto 0;
    }
}
.sw-message .container1 .cn7:hover {
    background-color: rgba(255, 93, 0, 0.9);
}
</style>
